<div [id]="getId()" class="modal modal-lg accessibility-modal" data-backdrop="static" data-keyboard="false"
    role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 id="shortcut-modal-title" class="modal-title">Tastaturkürzel & Barrierefreiheit</h2>
                <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
            </div>
            <div class="modal-body">
                <div class="shortcut-section">
                    <h3>Globale Navigation (Bereichs-Shortcuts)</h3>
                    <table class="table table-borderless align-middle" aria-label="Globale Navigation Tastaturkürzel">
                        <thead class="visually-hidden">
                            <tr>
                                <th scope="col">Tastenkombination</th>
                                <th scope="col">Aktion</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><kbd>{{ modifierKey }}</kbd> + <kbd>T</kbd></td>
                                <td>Kopfzeile (Top Bar) fokussieren</td>
                            </tr>
                            <tr>
                                <td><kbd>{{ modifierKey }}</kbd> + <kbd>M</kbd></td>
                                <td>Hauptinhalt (Aufgabenbereich) fokussieren</td>
                            </tr>
                            <tr>
                                <td><kbd>{{ modifierKey }}</kbd> + <kbd>L</kbd></td>
                                <td>Linke Werkzeugleiste (Sidebar) fokussieren</td>
                            </tr>
                            <tr>
                                <td><kbd>{{ modifierKey }}</kbd> + <kbd>R</kbd></td>
                                <td>Rechte Werkzeugleiste (Toolbar) fokussieren</td>
                            </tr>
                            <tr>
                                <td><kbd>{{ modifierKey }}</kbd> + <kbd>O</kbd></td>
                                <td>Kapitelübersicht öffnen</td>
                            </tr>
                            <tr>
                                <td><kbd>{{ modifierKey }}</kbd> + <kbd>Q</kbd></td>
                                <td>Schnellsuche öffnen / schließen</td>
                            </tr>
                            <tr>
                                <td><kbd>{{ modifierKey }}</kbd> + <kbd>P</kbd></td>
                                <td>Zum vorherigen Kapitel wechseln (nur wenn nicht in Textfeldern)</td>
                            </tr>
                            <tr>
                                <td><kbd>{{ modifierKey }}</kbd> + <kbd>N</kbd></td>
                                <td>Zum nächsten Kapitel wechseln (nur wenn nicht in Textfeldern)</td>
                            </tr>
                            <tr>
                                <td><kbd>&rarr;</kbd></td>
                                <td>Zur nächsten Seite wechseln</td>
                            </tr>
                            <tr>
                                <td><kbd>&larr;</kbd></td>
                                <td>Zur vorherigen Seite wechseln</td>
                            </tr>
                            <tr>
                                <td><kbd>{{ modifierKey }}</kbd> + <kbd>H</kbd></td>
                                <td>Übersicht der Tastaturkürzel anzeigen</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="shortcut-section mt-4">
                    <h3>Block-zu-Block Navigation (2-Ebenen Navigation)</h3>
                    <table class="table table-borderless align-middle" aria-label="Block Navigation Tastaturkürzel">
                        <thead class="visually-hidden">
                        <tr>
                            <th scope="col">Tastenkombination</th>
                            <th scope="col">Aktion</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td><kbd>Tab</kbd></td>
                            <td>Zum nächsten Block springen (Ebene 1)</td>
                        </tr>
                        <tr>
                            <td><kbd>Shift</kbd> + <kbd>Tab</kbd></td>
                            <td>Zum vorherigen Block springen (Ebene 1)</td>
                        </tr>
                        <tr>
                            <td><kbd>Enter</kbd> oder <kbd>Leertaste</kbd></td>
                            <td>Block öffnen (Ebene 2 aktivieren - Fokus geht hinein)</td>
                        </tr>
                        <tr>
                            <td><kbd>Tab</kbd> / <kbd>Shift+Tab</kbd> (in Ebene 2)</td>
                            <td>Navigiert ausschließlich innerhalb des aktuellen Blocks (Focus Trap)</td>
                        </tr>
                        <tr>
                            <td><kbd>Esc</kbd></td>
                            <td>Ebene 2 verlassen und zurück zur Ebene 1 wechseln</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>